/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineChangePreviewResponseOutputExpectedVersionExclusiveMin = 0;
export const routineChangePreviewResponseOutputExpectedVersionMax = 9007199254740991;

export const routineChangePreviewResponseOutputPreviewFingerprintMax = 256;

export const routineChangePreviewResponseOutputEffectiveAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputAffectedRoutineIdsItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewResponseOutputAffectedRoutineIdsMax = 10;

export const routineChangePreviewResponseOutputPendingChangesItemVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewResponseOutputPendingChangesItemActivatesAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputPendingChangesItemSavedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputPendingChangesItemEffectiveLocalDateRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
  );
export const routineChangePreviewResponseOutputPendingChangesMax = 2;

export const routineChangePreviewResponseOutputBeforeDaySlicesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputBeforeDaySlicesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputBeforeDaySlicesMax = 35;

export const routineChangePreviewResponseOutputBeforeAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewResponseOutputBeforeAgentsItemDisplayNameMax = 500;

export const routineChangePreviewResponseOutputBeforeAgentsItemInitialsMax = 8;

export const routineChangePreviewResponseOutputBeforeAgentsMax = 1000;

export const routineChangePreviewResponseOutputBeforeRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputBeforeRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputBeforeDisplayTimeZoneMax = 100;

export const routineChangePreviewResponseOutputBeforeSchedulesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewResponseOutputBeforeSchedulesItemTimeZoneMax = 100;

export const routineChangePreviewResponseOutputBeforeSchedulesItemVersionExclusiveMin = 0;
export const routineChangePreviewResponseOutputBeforeSchedulesItemVersionMax = 9007199254740991;

export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemPendingHistoryOneEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalMax = 10000;

export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesMax = 10000;

export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalMax = 10000;

export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemGapsItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemGapsItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemGapsMax = 10000;

export const routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesMax = 10;

export const routineChangePreviewResponseOutputBeforeSchedulesMax = 300;

export const routineChangePreviewResponseOutputBeforeViewVersionMax = 256;

export const routineChangePreviewResponseOutputAfterDaySlicesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputAfterDaySlicesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputAfterDaySlicesMax = 35;

export const routineChangePreviewResponseOutputAfterAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewResponseOutputAfterAgentsItemDisplayNameMax = 500;

export const routineChangePreviewResponseOutputAfterAgentsItemInitialsMax = 8;

export const routineChangePreviewResponseOutputAfterAgentsMax = 1000;

export const routineChangePreviewResponseOutputAfterRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputAfterRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputAfterDisplayTimeZoneMax = 100;

export const routineChangePreviewResponseOutputAfterSchedulesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangePreviewResponseOutputAfterSchedulesItemTimeZoneMax = 100;

export const routineChangePreviewResponseOutputAfterSchedulesItemVersionExclusiveMin = 0;
export const routineChangePreviewResponseOutputAfterSchedulesItemVersionMax = 9007199254740991;

export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemPendingHistoryOneEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalMax = 10000;

export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesMax = 10000;

export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalMax = 10000;

export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemGapsItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemGapsItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemGapsMax = 10000;

export const routineChangePreviewResponseOutputAfterSchedulesItemRoutinesMax = 10;

export const routineChangePreviewResponseOutputAfterSchedulesMax = 300;

export const routineChangePreviewResponseOutputAfterViewVersionMax = 256;

export const routineChangePreviewResponseOutputChangeActivationsSectionsRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputChangeActivationsRotationRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputRotationTransitionActivatesAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputRotationTransitionOutgoingOneUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputRotationTransitionOutgoingOneOrdinalMin = 0;
export const routineChangePreviewResponseOutputRotationTransitionOutgoingOneOrdinalMax = 19;

export const routineChangePreviewResponseOutputRotationTransitionOutgoingOneEndsAtOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputRotationTransitionIncomingOneUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputRotationTransitionIncomingOneOrdinalMin = 0;
export const routineChangePreviewResponseOutputRotationTransitionIncomingOneOrdinalMax = 19;

export const routineChangePreviewResponseOutputRoutineEndAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDaySlicesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDaySlicesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDaySlicesMax = 35;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsItemIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsItemDisplayNameMax = 500;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsItemInitialsMax = 8;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsMax = 1000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeRangeStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeRangeEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDisplayTimeZoneMax = 100;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemTimeZoneMax = 100;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemVersionExclusiveMin = 0;
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemVersionMax = 9007199254740991;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemPendingHistoryOneEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemGapsItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemGapsItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemGapsMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesMax = 10;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesMax = 300;

export const routineChangePreviewResponseOutputAdditionalWindowsItemBeforeViewVersionMax = 256;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterDaySlicesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterDaySlicesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterDaySlicesMax = 35;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsItemIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsItemDisplayNameMax = 500;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsItemInitialsMax = 8;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsMax = 1000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterRangeStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterRangeEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterDisplayTimeZoneMax = 100;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemTimeZoneMax = 100;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemVersionExclusiveMin = 0;
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemVersionMax = 9007199254740991;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemPendingHistoryOneEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemGapsItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemGapsItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemGapsMax = 10000;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesMax = 10;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesMax = 300;

export const routineChangePreviewResponseOutputAdditionalWindowsItemAfterViewVersionMax = 256;

export const routineChangePreviewResponseOutputAdditionalWindowsMax = 3;

export const routineChangePreviewResponseOutputNewGapsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputNewGapsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangePreviewResponseOutputNewGapsMax = 10000;

export const RoutineChangePreviewResponseOutput = zod.object({
  expectedVersion: zod
    .int()
    .gt(routineChangePreviewResponseOutputExpectedVersionExclusiveMin)
    .max(routineChangePreviewResponseOutputExpectedVersionMax),
  previewFingerprint: zod
    .string()
    .min(1)
    .max(routineChangePreviewResponseOutputPreviewFingerprintMax),
  effectiveAt: zod.iso
    .datetime({ offset: true })
    .regex(routineChangePreviewResponseOutputEffectiveAtRegExp),
  affectedRoutineIds: zod
    .array(zod.uuid().regex(routineChangePreviewResponseOutputAffectedRoutineIdsItemRegExp))
    .max(routineChangePreviewResponseOutputAffectedRoutineIdsMax),
  pendingChanges: zod
    .array(
      zod.object({
        kind: zod.enum(['sections', 'rotation']),
        versionId: zod
          .uuid()
          .regex(routineChangePreviewResponseOutputPendingChangesItemVersionIdRegExp),
        activatesAt: zod.iso
          .datetime({ offset: true })
          .regex(routineChangePreviewResponseOutputPendingChangesItemActivatesAtRegExp),
        savedAt: zod.iso
          .datetime({ offset: true })
          .regex(routineChangePreviewResponseOutputPendingChangesItemSavedAtRegExp),
        effectiveLocalDate: zod.iso
          .date()
          .regex(routineChangePreviewResponseOutputPendingChangesItemEffectiveLocalDateRegExp)
          .optional(),
      }),
    )
    .max(routineChangePreviewResponseOutputPendingChangesMax),
  before: zod.object({
    daySlices: zod
      .array(
        zod.object({
          start: zod.iso
            .datetime({ offset: true })
            .regex(routineChangePreviewResponseOutputBeforeDaySlicesItemStartRegExp),
          end: zod.iso
            .datetime({ offset: true })
            .regex(routineChangePreviewResponseOutputBeforeDaySlicesItemEndRegExp),
        }),
      )
      .max(routineChangePreviewResponseOutputBeforeDaySlicesMax)
      .optional(),
    agents: zod
      .array(
        zod.object({
          id: zod.uuid().regex(routineChangePreviewResponseOutputBeforeAgentsItemIdRegExp),
          displayName: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputBeforeAgentsItemDisplayNameMax),
          initials: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputBeforeAgentsItemInitialsMax),
        }),
      )
      .max(routineChangePreviewResponseOutputBeforeAgentsMax)
      .optional(),
    range: zod.object({
      start: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputBeforeRangeStartRegExp),
      end: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputBeforeRangeEndRegExp),
    }),
    displayTimeZone: zod
      .string()
      .min(1)
      .max(routineChangePreviewResponseOutputBeforeDisplayTimeZoneMax),
    schedules: zod
      .array(
        zod.object({
          scheduleId: zod
            .uuid()
            .regex(routineChangePreviewResponseOutputBeforeSchedulesItemScheduleIdRegExp),
          name: zod.unknown().and(zod.unknown()),
          timeZone: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputBeforeSchedulesItemTimeZoneMax),
          version: zod
            .int()
            .gt(routineChangePreviewResponseOutputBeforeSchedulesItemVersionExclusiveMin)
            .max(routineChangePreviewResponseOutputBeforeSchedulesItemVersionMax),
          routines: zod
            .array(
              zod.object({
                pendingHistory: zod
                  .union([
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                        ),
                    }),
                    zod.null(),
                  ])
                  .optional(),
                routineId: zod
                  .uuid()
                  .regex(
                    routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemRoutineIdRegExp,
                  ),
                name: zod.unknown().and(zod.unknown()),
                rotation: zod.object({
                  unit: zod.enum(['day', 'week']),
                  count: zod
                    .int()
                    .gt(
                      routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemRotationCountExclusiveMin,
                    )
                    .max(
                      routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemRotationCountMax,
                    ),
                }),
                original: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemEndRegExp,
                        ),
                      source: zod.object({
                        scheduleId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                          ),
                        routineId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                          ),
                        routineVersionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                          ),
                        positionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                          ),
                        originalUserId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                          ),
                        originalEligible: zod.boolean(),
                        overrideId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                      }),
                      userId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      eligible: zod.boolean(),
                      startOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                        ),
                      endOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                        ),
                      history: zod.object({
                        recordedThrough: zod.union([
                          zod.iso
                            .datetime({ offset: true })
                            .regex(
                              routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        finalized: zod.boolean(),
                      }),
                    }),
                  )
                  .max(
                    routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOriginalMax,
                  ),
                overrides: zod
                  .array(
                    zod.object({
                      overrideId: zod
                        .uuid()
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                        ),
                      substituteUserId: zod
                        .uuid()
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                        ),
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesItemEndRegExp,
                        ),
                      effective: zod.boolean(),
                      eligible: zod.boolean(),
                    }),
                  )
                  .max(
                    routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemOverridesMax,
                  ),
                final: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemEndRegExp,
                        ),
                      source: zod.object({
                        scheduleId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                          ),
                        routineId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                          ),
                        routineVersionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                          ),
                        positionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                          ),
                        originalUserId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                          ),
                        originalEligible: zod.boolean(),
                        overrideId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                      }),
                      userId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      eligible: zod.boolean(),
                      startOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                        ),
                      endOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                        ),
                      history: zod.object({
                        recordedThrough: zod.union([
                          zod.iso
                            .datetime({ offset: true })
                            .regex(
                              routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        finalized: zod.boolean(),
                      }),
                    }),
                  )
                  .max(routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemFinalMax),
                gaps: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemGapsItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemGapsItemEndRegExp,
                        ),
                      reason: zod.enum([
                        'outside-sections',
                        'before-start',
                        'ineligible',
                        'ended',
                        'archived',
                        'empty-dst-section',
                      ]),
                    }),
                  )
                  .max(routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesItemGapsMax),
              }),
            )
            .max(routineChangePreviewResponseOutputBeforeSchedulesItemRoutinesMax),
        }),
      )
      .max(routineChangePreviewResponseOutputBeforeSchedulesMax),
    viewVersion: zod.string().min(1).max(routineChangePreviewResponseOutputBeforeViewVersionMax),
  }),
  after: zod.object({
    daySlices: zod
      .array(
        zod.object({
          start: zod.iso
            .datetime({ offset: true })
            .regex(routineChangePreviewResponseOutputAfterDaySlicesItemStartRegExp),
          end: zod.iso
            .datetime({ offset: true })
            .regex(routineChangePreviewResponseOutputAfterDaySlicesItemEndRegExp),
        }),
      )
      .max(routineChangePreviewResponseOutputAfterDaySlicesMax)
      .optional(),
    agents: zod
      .array(
        zod.object({
          id: zod.uuid().regex(routineChangePreviewResponseOutputAfterAgentsItemIdRegExp),
          displayName: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAfterAgentsItemDisplayNameMax),
          initials: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAfterAgentsItemInitialsMax),
        }),
      )
      .max(routineChangePreviewResponseOutputAfterAgentsMax)
      .optional(),
    range: zod.object({
      start: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputAfterRangeStartRegExp),
      end: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputAfterRangeEndRegExp),
    }),
    displayTimeZone: zod
      .string()
      .min(1)
      .max(routineChangePreviewResponseOutputAfterDisplayTimeZoneMax),
    schedules: zod
      .array(
        zod.object({
          scheduleId: zod
            .uuid()
            .regex(routineChangePreviewResponseOutputAfterSchedulesItemScheduleIdRegExp),
          name: zod.unknown().and(zod.unknown()),
          timeZone: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAfterSchedulesItemTimeZoneMax),
          version: zod
            .int()
            .gt(routineChangePreviewResponseOutputAfterSchedulesItemVersionExclusiveMin)
            .max(routineChangePreviewResponseOutputAfterSchedulesItemVersionMax),
          routines: zod
            .array(
              zod.object({
                pendingHistory: zod
                  .union([
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                        ),
                    }),
                    zod.null(),
                  ])
                  .optional(),
                routineId: zod
                  .uuid()
                  .regex(
                    routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemRoutineIdRegExp,
                  ),
                name: zod.unknown().and(zod.unknown()),
                rotation: zod.object({
                  unit: zod.enum(['day', 'week']),
                  count: zod
                    .int()
                    .gt(
                      routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemRotationCountExclusiveMin,
                    )
                    .max(
                      routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemRotationCountMax,
                    ),
                }),
                original: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemEndRegExp,
                        ),
                      source: zod.object({
                        scheduleId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                          ),
                        routineId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                          ),
                        routineVersionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                          ),
                        positionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                          ),
                        originalUserId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                          ),
                        originalEligible: zod.boolean(),
                        overrideId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                      }),
                      userId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      eligible: zod.boolean(),
                      startOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                        ),
                      endOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                        ),
                      history: zod.object({
                        recordedThrough: zod.union([
                          zod.iso
                            .datetime({ offset: true })
                            .regex(
                              routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        finalized: zod.boolean(),
                      }),
                    }),
                  )
                  .max(routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOriginalMax),
                overrides: zod
                  .array(
                    zod.object({
                      overrideId: zod
                        .uuid()
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                        ),
                      substituteUserId: zod
                        .uuid()
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                        ),
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesItemEndRegExp,
                        ),
                      effective: zod.boolean(),
                      eligible: zod.boolean(),
                    }),
                  )
                  .max(
                    routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemOverridesMax,
                  ),
                final: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemEndRegExp,
                        ),
                      source: zod.object({
                        scheduleId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                          ),
                        routineId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                          ),
                        routineVersionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                          ),
                        positionId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                          ),
                        originalUserId: zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                          ),
                        originalEligible: zod.boolean(),
                        overrideId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                      }),
                      userId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      eligible: zod.boolean(),
                      startOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                        ),
                      endOffset: zod
                        .string()
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                        ),
                      history: zod.object({
                        recordedThrough: zod.union([
                          zod.iso
                            .datetime({ offset: true })
                            .regex(
                              routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        finalized: zod.boolean(),
                      }),
                    }),
                  )
                  .max(routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemFinalMax),
                gaps: zod
                  .array(
                    zod.object({
                      start: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemGapsItemStartRegExp,
                        ),
                      end: zod.iso
                        .datetime({ offset: true })
                        .regex(
                          routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemGapsItemEndRegExp,
                        ),
                      reason: zod.enum([
                        'outside-sections',
                        'before-start',
                        'ineligible',
                        'ended',
                        'archived',
                        'empty-dst-section',
                      ]),
                    }),
                  )
                  .max(routineChangePreviewResponseOutputAfterSchedulesItemRoutinesItemGapsMax),
              }),
            )
            .max(routineChangePreviewResponseOutputAfterSchedulesItemRoutinesMax),
        }),
      )
      .max(routineChangePreviewResponseOutputAfterSchedulesMax),
    viewVersion: zod.string().min(1).max(routineChangePreviewResponseOutputAfterViewVersionMax),
  }),
  changeActivations: zod
    .object({
      sections: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputChangeActivationsSectionsRegExp)
        .optional(),
      rotation: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputChangeActivationsRotationRegExp)
        .optional(),
    })
    .optional(),
  rotationTransition: zod
    .object({
      activatesAt: zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputRotationTransitionActivatesAtRegExp),
      preservesOutgoingTurn: zod.boolean().optional(),
      outgoing: zod.union([
        zod.object({
          userId: zod
            .uuid()
            .regex(routineChangePreviewResponseOutputRotationTransitionOutgoingOneUserIdRegExp),
          ordinal: zod
            .int()
            .min(routineChangePreviewResponseOutputRotationTransitionOutgoingOneOrdinalMin)
            .max(routineChangePreviewResponseOutputRotationTransitionOutgoingOneOrdinalMax),
          endsAt: zod.union([
            zod.iso
              .datetime({ offset: true })
              .regex(
                routineChangePreviewResponseOutputRotationTransitionOutgoingOneEndsAtOneRegExp,
              ),
            zod.null(),
          ]),
        }),
        zod.null(),
      ]),
      incoming: zod.union([
        zod.object({
          userId: zod
            .uuid()
            .regex(routineChangePreviewResponseOutputRotationTransitionIncomingOneUserIdRegExp),
          ordinal: zod
            .int()
            .min(routineChangePreviewResponseOutputRotationTransitionIncomingOneOrdinalMin)
            .max(routineChangePreviewResponseOutputRotationTransitionIncomingOneOrdinalMax),
          startsFreshTurn: zod.boolean().optional(),
        }),
        zod.null(),
      ]),
    })
    .optional(),
  routineEndAt: zod
    .union([
      zod.iso
        .datetime({ offset: true })
        .regex(routineChangePreviewResponseOutputRoutineEndAtOneRegExp),
      zod.null(),
    ])
    .optional(),
  additionalWindows: zod
    .array(
      zod.object({
        before: zod.object({
          daySlices: zod
            .array(
              zod.object({
                start: zod.iso
                  .datetime({ offset: true })
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDaySlicesItemStartRegExp,
                  ),
                end: zod.iso
                  .datetime({ offset: true })
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDaySlicesItemEndRegExp,
                  ),
              }),
            )
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDaySlicesMax)
            .optional(),
          agents: zod
            .array(
              zod.object({
                id: zod
                  .uuid()
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsItemIdRegExp,
                  ),
                displayName: zod
                  .string()
                  .min(1)
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsItemDisplayNameMax,
                  ),
                initials: zod
                  .string()
                  .min(1)
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsItemInitialsMax,
                  ),
              }),
            )
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeAgentsMax)
            .optional(),
          range: zod.object({
            start: zod.iso
              .datetime({ offset: true })
              .regex(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeRangeStartRegExp),
            end: zod.iso
              .datetime({ offset: true })
              .regex(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeRangeEndRegExp),
          }),
          displayTimeZone: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeDisplayTimeZoneMax),
          schedules: zod
            .array(
              zod.object({
                scheduleId: zod
                  .uuid()
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemScheduleIdRegExp,
                  ),
                name: zod.unknown().and(zod.unknown()),
                timeZone: zod
                  .string()
                  .min(1)
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemTimeZoneMax,
                  ),
                version: zod
                  .int()
                  .gt(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemVersionExclusiveMin,
                  )
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemVersionMax,
                  ),
                routines: zod
                  .array(
                    zod.object({
                      pendingHistory: zod
                        .union([
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                              ),
                          }),
                          zod.null(),
                        ])
                        .optional(),
                      routineId: zod
                        .uuid()
                        .regex(
                          routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemRoutineIdRegExp,
                        ),
                      name: zod.unknown().and(zod.unknown()),
                      rotation: zod.object({
                        unit: zod.enum(['day', 'week']),
                        count: zod
                          .int()
                          .gt(
                            routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemRotationCountExclusiveMin,
                          )
                          .max(
                            routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemRotationCountMax,
                          ),
                      }),
                      original: zod
                        .array(
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemEndRegExp,
                              ),
                            source: zod.object({
                              scheduleId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                                ),
                              routineId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                                ),
                              routineVersionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                                ),
                              positionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                                ),
                              originalUserId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                                ),
                              originalEligible: zod.boolean(),
                              overrideId: zod.union([
                                zod
                                  .uuid()
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                            }),
                            userId: zod.union([
                              zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                                ),
                              zod.null(),
                            ]),
                            eligible: zod.boolean(),
                            startOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                              ),
                            endOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                              ),
                            history: zod.object({
                              recordedThrough: zod.union([
                                zod.iso
                                  .datetime({ offset: true })
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                              finalized: zod.boolean(),
                            }),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOriginalMax,
                        ),
                      overrides: zod
                        .array(
                          zod.object({
                            overrideId: zod
                              .uuid()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                              ),
                            substituteUserId: zod
                              .uuid()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                              ),
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesItemEndRegExp,
                              ),
                            effective: zod.boolean(),
                            eligible: zod.boolean(),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemOverridesMax,
                        ),
                      final: zod
                        .array(
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemEndRegExp,
                              ),
                            source: zod.object({
                              scheduleId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                                ),
                              routineId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                                ),
                              routineVersionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                                ),
                              positionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                                ),
                              originalUserId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                                ),
                              originalEligible: zod.boolean(),
                              overrideId: zod.union([
                                zod
                                  .uuid()
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                            }),
                            userId: zod.union([
                              zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                                ),
                              zod.null(),
                            ]),
                            eligible: zod.boolean(),
                            startOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                              ),
                            endOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                              ),
                            history: zod.object({
                              recordedThrough: zod.union([
                                zod.iso
                                  .datetime({ offset: true })
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                              finalized: zod.boolean(),
                            }),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemFinalMax,
                        ),
                      gaps: zod
                        .array(
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemGapsItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemGapsItemEndRegExp,
                              ),
                            reason: zod.enum([
                              'outside-sections',
                              'before-start',
                              'ineligible',
                              'ended',
                              'archived',
                              'empty-dst-section',
                            ]),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesItemGapsMax,
                        ),
                    }),
                  )
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesItemRoutinesMax,
                  ),
              }),
            )
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeSchedulesMax),
          viewVersion: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemBeforeViewVersionMax),
        }),
        after: zod.object({
          daySlices: zod
            .array(
              zod.object({
                start: zod.iso
                  .datetime({ offset: true })
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterDaySlicesItemStartRegExp,
                  ),
                end: zod.iso
                  .datetime({ offset: true })
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterDaySlicesItemEndRegExp,
                  ),
              }),
            )
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemAfterDaySlicesMax)
            .optional(),
          agents: zod
            .array(
              zod.object({
                id: zod
                  .uuid()
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsItemIdRegExp,
                  ),
                displayName: zod
                  .string()
                  .min(1)
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsItemDisplayNameMax,
                  ),
                initials: zod
                  .string()
                  .min(1)
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsItemInitialsMax,
                  ),
              }),
            )
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemAfterAgentsMax)
            .optional(),
          range: zod.object({
            start: zod.iso
              .datetime({ offset: true })
              .regex(routineChangePreviewResponseOutputAdditionalWindowsItemAfterRangeStartRegExp),
            end: zod.iso
              .datetime({ offset: true })
              .regex(routineChangePreviewResponseOutputAdditionalWindowsItemAfterRangeEndRegExp),
          }),
          displayTimeZone: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemAfterDisplayTimeZoneMax),
          schedules: zod
            .array(
              zod.object({
                scheduleId: zod
                  .uuid()
                  .regex(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemScheduleIdRegExp,
                  ),
                name: zod.unknown().and(zod.unknown()),
                timeZone: zod
                  .string()
                  .min(1)
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemTimeZoneMax,
                  ),
                version: zod
                  .int()
                  .gt(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemVersionExclusiveMin,
                  )
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemVersionMax,
                  ),
                routines: zod
                  .array(
                    zod.object({
                      pendingHistory: zod
                        .union([
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                              ),
                          }),
                          zod.null(),
                        ])
                        .optional(),
                      routineId: zod
                        .uuid()
                        .regex(
                          routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemRoutineIdRegExp,
                        ),
                      name: zod.unknown().and(zod.unknown()),
                      rotation: zod.object({
                        unit: zod.enum(['day', 'week']),
                        count: zod
                          .int()
                          .gt(
                            routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemRotationCountExclusiveMin,
                          )
                          .max(
                            routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemRotationCountMax,
                          ),
                      }),
                      original: zod
                        .array(
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemEndRegExp,
                              ),
                            source: zod.object({
                              scheduleId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                                ),
                              routineId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                                ),
                              routineVersionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                                ),
                              positionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                                ),
                              originalUserId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                                ),
                              originalEligible: zod.boolean(),
                              overrideId: zod.union([
                                zod
                                  .uuid()
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                            }),
                            userId: zod.union([
                              zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                                ),
                              zod.null(),
                            ]),
                            eligible: zod.boolean(),
                            startOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                              ),
                            endOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                              ),
                            history: zod.object({
                              recordedThrough: zod.union([
                                zod.iso
                                  .datetime({ offset: true })
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                              finalized: zod.boolean(),
                            }),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOriginalMax,
                        ),
                      overrides: zod
                        .array(
                          zod.object({
                            overrideId: zod
                              .uuid()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                              ),
                            substituteUserId: zod
                              .uuid()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                              ),
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesItemEndRegExp,
                              ),
                            effective: zod.boolean(),
                            eligible: zod.boolean(),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemOverridesMax,
                        ),
                      final: zod
                        .array(
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemEndRegExp,
                              ),
                            source: zod.object({
                              scheduleId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                                ),
                              routineId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                                ),
                              routineVersionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                                ),
                              positionId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                                ),
                              originalUserId: zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                                ),
                              originalEligible: zod.boolean(),
                              overrideId: zod.union([
                                zod
                                  .uuid()
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                            }),
                            userId: zod.union([
                              zod
                                .uuid()
                                .regex(
                                  routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                                ),
                              zod.null(),
                            ]),
                            eligible: zod.boolean(),
                            startOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                              ),
                            endOffset: zod
                              .string()
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                              ),
                            history: zod.object({
                              recordedThrough: zod.union([
                                zod.iso
                                  .datetime({ offset: true })
                                  .regex(
                                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                                  ),
                                zod.null(),
                              ]),
                              finalized: zod.boolean(),
                            }),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemFinalMax,
                        ),
                      gaps: zod
                        .array(
                          zod.object({
                            start: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemGapsItemStartRegExp,
                              ),
                            end: zod.iso
                              .datetime({ offset: true })
                              .regex(
                                routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemGapsItemEndRegExp,
                              ),
                            reason: zod.enum([
                              'outside-sections',
                              'before-start',
                              'ineligible',
                              'ended',
                              'archived',
                              'empty-dst-section',
                            ]),
                          }),
                        )
                        .max(
                          routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesItemGapsMax,
                        ),
                    }),
                  )
                  .max(
                    routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesItemRoutinesMax,
                  ),
              }),
            )
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemAfterSchedulesMax),
          viewVersion: zod
            .string()
            .min(1)
            .max(routineChangePreviewResponseOutputAdditionalWindowsItemAfterViewVersionMax),
        }),
      }),
    )
    .max(routineChangePreviewResponseOutputAdditionalWindowsMax)
    .optional(),
  newGaps: zod
    .array(
      zod.object({
        start: zod.iso
          .datetime({ offset: true })
          .regex(routineChangePreviewResponseOutputNewGapsItemStartRegExp),
        end: zod.iso
          .datetime({ offset: true })
          .regex(routineChangePreviewResponseOutputNewGapsItemEndRegExp),
        reason: zod.enum([
          'outside-sections',
          'before-start',
          'ineligible',
          'ended',
          'archived',
          'empty-dst-section',
        ]),
      }),
    )
    .max(routineChangePreviewResponseOutputNewGapsMax),
});

export type RoutineChangePreviewResponseOutput = zod.input<
  typeof RoutineChangePreviewResponseOutput
>;
export type RoutineChangePreviewResponseOutputOutput = zod.output<
  typeof RoutineChangePreviewResponseOutput
>;
